import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import OrderCreateSF from '../../components/finapp/order/OrderCreateSF'

const OrderCreatePageUI = ({context, messageList}) =>
  <PrivatePageSF context={context} className='pg_ord_crt' backLink='/orders'
    messageList={messageList} headerMessageKey='c_create_order'
  >
    <PageTitleUI context={context} goBack={true} backLink='/orders' messageList={messageList} titleMessageKey='c_create_order' />
    <OrderCreateSF context={context} messageList={messageList} />
  </PrivatePageSF>

export default OrderCreatePageUI
